import { selectData } from "fe-shared/utils/reducerUtils";

import api from "api";
import conversationApi from "api/conversation";
import webbotActions from "./webbot";
import { createApiAction } from "./base";
import {
  CONFIG_GET_RESPONSE,
  CONFIG_ERROR,
  CONFIG_REQUEST,
  CONFIG_UPDATE_DATA,
  WEBBOT_RESET_CHAT,
  WEBBOT_RESTARTING_CHAT,
} from "./const";

const updateConfigData =
  ({ path, value }) =>
  dispatch => {
    dispatch({
      type: CONFIG_UPDATE_DATA,
      payload: {
        path,
        value,
      },
    });
  };

const getConfig = createApiAction(
  ({ id, newChannel }) => {
    if (newChannel) {
      return api.config.getItNewChannel({
        id: `${id}/config/`,
        data: { newChannel },
      });
    }
    return api.config.getIt({ id: `${id}/configuration/` });
  },
  {
    errorType: CONFIG_ERROR,
    requestType: CONFIG_REQUEST,
    responseType: CONFIG_GET_RESPONSE,
  }
);

const getConfigAndMakeConnection = createApiAction(
  ({ id, newChannel }) => {
    if (newChannel) {
      return api.config.getItNewChannel({
        id: `${id}/config/`,
        data: { newChannel },
      });
    }
    return api.config.getIt({ id: `${id}/configuration/` });
  },
  {
    errorType: CONFIG_ERROR,
    requestType: CONFIG_REQUEST,
    responseType: CONFIG_GET_RESPONSE,
    onResponse: (dispatch, data, args) => {
      if (!args.autoLoad) {
        const websocket = data.getIn(["styles", "demo"]);
        webbotActions.makeConnection({
          id: websocket || args.id,
          receivedUserId: args.userId,
          receivedReferral: args.referral,
          testing: args.testing,
          newChannel: args.newChannel,
          noDelay: args.noDelayMode,
          cvars: args.cvars,
          origin: args.origin,
          webchatKey: args.webchatKey,
          voiceEnabled: args.voiceEnabled,
          web: args.web,
        })(dispatch);
      }
    },
  }
);

const startWebsocket = data => dispatch =>
  webbotActions.makeConnection({
    id: data.id,
    receivedUserId: data.userId,
    receivedReferral: data.referral,
    testing: data.testing,
    origin: data.origin,
    newChannel: data.newChannel,
    noDelay: data.noDelayMode,
    cvars: data.cvars,
    webchatKey: data.webchatKey,
    voiceEnabled: data.voiceEnabled,
    web: data.web,
  })(dispatch);

export const restartWebsocket =
  ({ dataToWebsocket, dataToResetConversation, forceReset }) =>
  dispatch => {
    const {
      id: botId,
      module_id: moduleId,
      version_name: versionName,
    } = dataToResetConversation;

    const openConnection = ({
      id,
      userId,
      referral,
      testing,
      origin,
      newChannel,
      noDelayMode,
      cvars,
      webchatKey,
      voiceEnabled,
      web,
    }) => {
      if (forceReset) {
        console.log('forceReset')
        dispatch({ type: WEBBOT_RESET_CHAT });
      }

      webbotActions.makeConnection({
        noDelay: noDelayMode,
        receivedUserId: userId,
        receivedReferral: referral,
        id,
        cvars,
        origin,
        testing,
        newChannel,
        webchatKey,
        voiceEnabled,
        web,
      })(dispatch);
    };

    dispatch({ type: WEBBOT_RESTARTING_CHAT });
    console.log('restartWebsocket')
    webbotActions.closeConnectionWS();
    if (botId && moduleId && versionName) {
      console.log('botId && moduleId && versionName')
      conversationApi.testFromHere(dataToResetConversation).then(data => {
        console.log('data', data)
        const userId = selectData(data, "user_id");
        openConnection({ ...dataToWebsocket, userId });
      });
    } else {
      openConnection(dataToWebsocket);
    }
  };

export default {
  getConfig,
  getConfigAndMakeConnection,
  updateConfigData,
  startWebsocket,
  restartWebsocket,
};
